"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReactSelectOptionsFromMembers = void 0;
var getReactSelectOptionsFromMembers = function getReactSelectOptionsFromMembers(members) {
  return members.map(function (member) {
    var _member$user, _member$user2;
    return {
      value: (_member$user = member.user) === null || _member$user === void 0 ? void 0 : _member$user.id,
      label: (_member$user2 = member.user) === null || _member$user2 === void 0 ? void 0 : _member$user2.name
    };
  });
};
exports.getReactSelectOptionsFromMembers = getReactSelectOptionsFromMembers;